import React from 'react';
import { CTAButton } from './CTAButton';
import { MoonIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-29">
      {/* Background glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-blue-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-30" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-31">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-32">
          {/* Text Content */}
          <div className="flex flex-col items-start text-left" data-id="element-33">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 font-medium text-sm mb-6" data-id="element-34">
              <MoonIcon className="w-4 h-4" data-id="element-35" />
              <span data-id="element-36">Método Científicamente Probado</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-37">
              Protocolo Adiós Insomnio 3AM:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600" data-id="element-38">
                El Interruptor Biológico
              </span>{' '}
              para Apagar tu Cerebro en 15 Minutos
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 mb-8 leading-relaxed" data-id="element-39">
              Deja de calcular cuántas horas te quedan de sueño y recupera el
              control de tu descanso sin usar pastillas que te dejan como un
              zombie al día siguiente.
            </p>

            <CTAButton className="mb-8" data-id="element-40" />

            <p className="text-sm text-slate-400 flex items-center gap-2" data-id="element-41">
              <span className="flex h-2 w-2 rounded-full bg-green-500" data-id="element-42"></span>
              Acceso instantáneo. Descarga digital inmediata.
            </p>
          </div>

          {/* Image */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-43">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-transparent rounded-2xl blur-2xl transform rotate-3 scale-105" data-id="element-44" />
            <img src="https://cdn.magicpatterns.com/uploads/jRPM3wwhqZdPRBZFbQeHvg/ADIOS_INSOMNIO_3AM.png" alt="Protocolo Adiós Insomnio 3AM en una tablet sobre una mesa de noche" className="relative rounded-2xl shadow-2xl border border-slate-700/50 w-full object-cover z-10" data-id="element-45" />
          </div>
        </div>
      </div>
    </section>;
}